import { render, staticRenderFns } from "./multisource-health-facility.vue?vue&type=template&id=45b44595&scoped=true"
import script from "./multisource-health-facility.vue?vue&type=script&lang=js"
export * from "./multisource-health-facility.vue?vue&type=script&lang=js"
import style0 from "./multisource-health-facility.vue?vue&type=style&index=0&id=45b44595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b44595",
  null
  
)

export default component.exports